module.exports = __webpack_public_path__ + "img/fuwu7.a7623722.png";